import { Paper, Stack, Typography } from '@mui/material';
import { AxiosError } from 'axios';
import PageSad from 'illustrations/PageSad';
import React from 'react';

interface IErrorViewProps {
	error?: Error | string;
}

const ErrorView: React.FC<IErrorViewProps> = ({ error = null }) => {
	let title = intl.tr('errorView.title');
	let message = intl.tr('errorView.message');
	// istanbul ignore next
	if (error instanceof AxiosError && error.status === 401) {
		title = intl.tr('errorView.unauthorized.title');
		message = intl.tr('errorView.unauthorized.message');
	}

	return (
		<Paper elevation={0} sx={{ width: '100%', height: '100%' }}>
			<Stack
				data-testid="error-view"
				direction="column"
				alignItems="center"
				height="100%"
				gap={2}
				mt={10}
			>
				<PageSad height="30%" />
				<Typography variant="h4">{title}</Typography>
				<Typography variant="body1">{message}</Typography>
			</Stack>
		</Paper>
	);
};

export default ErrorView;
